import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AuthenticationModesResolutionFailedAction = {
	type: 'AUTHENTICATION_MODES_RESOLUTION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AuthenticationModesResolutionFailedAction => ({
	type: 'AUTHENTICATION_MODES_RESOLUTION_FAILED',
	payload,
});
